import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  /** Audit log index / dashboard widget (global list) */
  listLoading: false,
  /** Per-entity activity tab — isolated so slow/unrelated list fetches don’t block it */
  entityActivityLoading: false,
  error: "",
  auditLogList: null,
  entityActivity: null,
  entityTypes: null,
  exportLoading: false,
});

export default function auditReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.AUDIT_LOG_LIST.PENDING:
      return state.set("listLoading", true);
    case ACTIONS.AUDIT_LOG_LIST.SUCCESS:
      return state.set("listLoading", false).set("error", "").set("auditLogList", action.data);
    case ACTIONS.AUDIT_LOG_LIST.ERROR:
      return state.set("listLoading", false).set("error", action.error);

    case ACTIONS.ENTITY_ACTIVITY.PENDING:
      return state.set("entityActivityLoading", true);
    case ACTIONS.ENTITY_ACTIVITY.SUCCESS:
      return state.set("entityActivityLoading", false).set("error", "").set("entityActivity", action.data);
    case ACTIONS.ENTITY_ACTIVITY.ERROR:
      return state.set("entityActivityLoading", false).set("error", action.error);

    case ACTIONS.AUDIT_LOG_ENTITY_TYPES.SUCCESS:
      return state.set("entityTypes", action.data);

    case ACTIONS.AUDIT_LOG_EXPORT.PENDING:
      return state.set("exportLoading", true);
    case ACTIONS.AUDIT_LOG_EXPORT.SUCCESS:
      return state.set("exportLoading", false);
    case ACTIONS.AUDIT_LOG_EXPORT.ERROR:
      return state.set("exportLoading", false);

    case ACTIONS.RESET_ENTITY_ACTIVITY:
      return state.set("entityActivity", null).set("entityActivityLoading", false);

    default:
      return state;
  }
}
